import React from "react";
import { Wrench } from "lucide-react";
import { useSettingsStore } from "../../store/settingsStore";

export default function MaintenanceOverlay() {
    const { settings, loaded } = useSettingsStore();
    if (!loaded || !settings?.maintenance_mode) return null;

    return (
        <div
            className="fixed inset-0 z-[200] bg-dark-navy/95 backdrop-blur-md flex items-center justify-center px-6"
            data-testid="maintenance-overlay"
        >
            <div className="max-w-md text-center text-white">
                <div className="mx-auto w-16 h-16 rounded-full bg-gold/15 text-gold flex items-center justify-center">
                    <Wrench className="w-8 h-8" />
                </div>
                <h1 className="mt-5 text-3xl font-bold">Bakım Modundayız</h1>
                <p className="mt-3 text-white/80 leading-relaxed">
                    {settings?.maintenance_message ||
                        "Otel Pro şu anda bakımda. Kısa bir süre içinde tekrar yayında olacağız. Anlayışınız için teşekkür ederiz."}
                </p>
                <p className="mt-5 text-xs uppercase tracking-[0.25em] text-teal font-semibold">
                    www.otel-pro.com
                </p>
            </div>
        </div>
    );
}
